export const APPLY_CTA = 'Find my loan';
export const COOKIE_ACCEPT = 'Accept';
export const NEXT_CTA = 'Continue';
export const PREV_CTA = 'Back';
